import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./routes/AppRoutes";
import { PermissionProvider } from "./context/PermissionContext";
import "./App.css";

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <PermissionProvider>
          <AppRoutes />
        </PermissionProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
